import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const UserSelection = () => {
    return (
        <Container className="my-5 local-hire-design">
            <Row className="text-center mb-5">
                <Col>
                    <h1 className="text-primary fw-bold">Ingresa a Local Hire</h1>
                    <p className="lead text-secondary">Selecciona tu perfil para continuar</p>
                </Col>
            </Row>
            <Row className="justify-content-center">
                <Col xs={6} md={5} className="mb-4">
                    <Card className="h-100 text-center shadow-lg border-0">
                        <Card.Body className="p-3 p-md-5 d-flex flex-column align-items-center">
                            <div className="mb-3 display-1 d-none d-md-block">👤</div>
                            <div className="mb-2 display-4 d-md-none">👤</div>
                            <Card.Title className="fw-bold text-primary h2 mb-3 d-none d-md-block">Soy Cliente</Card.Title>
                            <Card.Title className="fw-bold text-primary h5 mb-2 d-md-none">Soy Cliente</Card.Title>
                            <Card.Text className="text-muted mb-4 lead d-none d-md-block">
                                Busco profesionales calificados para realizar tareas y servicios en mi hogar o empresa.
                            </Card.Text>
                            <Button as={Link} to="/servicelink" variant="primary" size="lg" className="rounded-pill w-100 mt-auto d-none d-md-block">
                                Buscar Servicios
                            </Button>
                            <Button as={Link} to="/servicelink" variant="primary" size="sm" className="rounded-pill w-100 mt-auto d-md-none">
                                Buscar
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={6} md={5} className="mb-4">
                    <Card className="h-100 text-center shadow-lg border-0">
                        <Card.Body className="p-3 p-md-5 d-flex flex-column align-items-center">
                            <div className="mb-3 display-1 d-none d-md-block">🛠️</div>
                            <div className="mb-2 display-4 d-md-none">🛠️</div>
                            <Card.Title className="fw-bold text-primary h2 mb-3 d-none d-md-block">Soy Proveedor</Card.Title>
                            <Card.Title className="fw-bold text-primary h5 mb-2 d-md-none">Soy Proveedor</Card.Title>
                            <Card.Text className="text-muted mb-4 lead d-none d-md-block">
                                Quiero ofrecer mis servicios, conseguir clientes y unirme a la comunidad de expertos.
                            </Card.Text>
                            <Button as={Link} to="/beone" variant="outline-primary" size="lg" className="rounded-pill w-100 mt-auto d-none d-md-block">
                                Unirme como Tasker
                            </Button>
                            <Button as={Link} to="/beone" variant="outline-primary" size="sm" className="rounded-pill w-100 mt-auto d-md-none">
                                Unirme
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default UserSelection;